import { handleRequest } from '../../api-service/apiService-helper';

export default async (props) => {
  return handleRequest({ ...props, type: 'download-file', module: 'download-manager' });
};
